import styled, { css } from 'styled-components';
import { FormTextAreaContainerProps, TextAreaProps, LabelProps, CharacterCounterProps } from './types';

export const FormTextAreaContainer = styled.div<FormTextAreaContainerProps>`
  display: flex;
  ${({ labelPosition }) =>
    labelPosition === 'left'
      ? css`
          flex-direction: row;
          align-items: flex-start;
        `
      : css`
          flex-direction: column;
        `}
  position: relative;
  align-items: center;
  width: ${({ fullWidth, width }) => (fullWidth ? '100%' : width || 'auto')};
  margin-bottom: 20px;
`;

export const Label = styled.label<LabelProps>`
  font-size: 15px;
  color: ${({ theme, hasError }) =>
    hasError ? theme.secondaryColor : theme.textColor};
  margin-bottom: ${({ labelPosition }) =>
    labelPosition === 'top' ? '6px' : '2em'};
  margin-right: ${({ labelPosition }) =>
    labelPosition === 'left' ? '10px' : '0'};
  font-weight: 700;
  transition: all 0.2s ease;
  white-space: nowrap;
  min-width: ${({ labelPosition }) =>
    labelPosition === 'left' ? '130px' : 'auto'};
  text-align: ${({ labelPosition }) =>
    labelPosition === 'left' ? 'right' : 'left'};

  ${({ required }) =>
    required &&
    css`
      &::after {
        content: '*';
        color: ${({ theme }) => theme.secondaryColor};
        margin-left: 4px;
      }
    `}
`;

export const TextArea = styled.textarea<TextAreaProps>`
  width: 100%;
  padding: 12px;
  border: 1px solid ${({ theme, hasError, isFocused }) =>
    hasError
      ? theme.secondaryColor
      : isFocused
        ? theme.primaryColor
        : theme.borderColor};
  border-radius: 4px;
  font-size: 14px;
  background-color: ${({ theme, disabled }) => disabled ? theme.lightGrayColor : theme.white};
  color: ${({ theme, disabled }) => disabled ? theme.darkGray : theme.textColor};
  transition: all 0.2s ease;
  outline: none;
  min-height: 100px;
  resize: none;
  overflow-y: auto;

  &:focus {
    border-color: ${({ theme, hasError }) => hasError ? theme.secondaryColor : theme.primaryColor};
    box-shadow: 0 0 0 2px ${({ theme, hasError }) =>
      hasError
        ? `${theme.secondaryColor}33`
        : `${theme.primaryColor}33`};
  }

  &::placeholder {
    color: ${({ theme }) => theme.darkGray};
    opacity: 0.7;
  }

  ${({ hasError, theme }) =>
    hasError &&
    css`
      border-color: ${theme.secondaryColor};
      &:focus {
        border-color: ${theme.secondaryColor};
      }
    `}
`;

export const ErrorMessage = styled.span`
  top: 100%;
  position: absolute;
  font-size: 12px;
  color: ${({ theme }) => theme.secondaryColor};
  margin-top: 4px;
  display: block;
`;

export const CharacterCounter = styled.div<CharacterCounterProps>`
  font-size: 12px;
  color: ${({ theme }) => theme.darkGray};
  margin-top: 4px;
  text-align: right;

  ${({ isNearMax, theme }) =>
    isNearMax && css`
      color: ${theme.secondaryColor};
      font-weight: 500;
    `
  }
`;


